import { Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ARCHIVED, CHECKED_IN, CREATED, FILE_ADDED, RESTORED, UPDATED } from '@careapp-group/core';
import { ViewCustomerTabs } from '../../customer/view-customer/view-customer-tabs';
import {
  resolveOrganisationIdFromRoute,
  resolveTenantIdFromRoute,
} from '../../shared/pipes/resolve-organisation-id-from-route';
import { OrganisationFeedItemDto } from '@careapp-group/ng-sdk';

@Pipe({
  name: 'feedItemLink',
  pure: true,
  standalone: false,
})
export class FeedItemLinkPipe implements PipeTransform {
  constructor(private route: ActivatedRoute) {}

  transform(item: OrganisationFeedItemDto) {
    if (!item) {
      return;
    }

    const tenantId = resolveTenantIdFromRoute(this.route);
    const orgId = resolveOrganisationIdFromRoute(this.route) ?? item.organisationId;
    if (!orgId || !tenantId) {
      return;
    }

    /**
     * In general:
     *  - Customer content (messages, videos, images etc.) can route to the messages page
     *  - Check-ins route to the community
     *  - Market orders route to the market order page
     */
    if (item.type === CHECKED_IN || item.type === UPDATED) {
      return { link: ['/', tenantId, `organisations`, orgId, 'communities', item.customerId] };
    }

    if (item.type === FILE_ADDED) {
      return {
        link: ['/', tenantId, `organisations`, orgId, 'communities', item.customerId],
        queryParams: {
          tab: ViewCustomerTabs.files,
        },
      };
    }

    if (
      item.relatesToModel === 'Customer' &&
      [CREATED, UPDATED, RESTORED, ARCHIVED].includes(item.type)
    ) {
      return { link: ['/', tenantId, `organisations`, orgId, 'communities', item.relatesToId] };
    }

    if (item.type === 'marketOrderCreated') {
      return {
        link: ['/', tenantId, `organisations`, orgId, 'market', 'orders', item.relatesToId],
      };
    }

    return { link: ['/', tenantId, `organisations`, orgId, 'messages', item.relatesToId] };
  }

  // For direct placement in the address bar.
  urlFriendly(item: OrganisationFeedItemDto) {
    const array1 = this.transform(item);
    const reduced = array1.link.reduce((prev, curr) => {
      if (curr == '/') {
        return `${prev}${curr}`;
      } else {
        return `${prev}/${curr}`;
      }
    }, '');

    return reduced;
  }
}
